import React from 'react';
import { motion } from 'framer-motion';
const beliefs = [{
  title: 'Enterprise AI fails at the organizational layer, not the technical one.',
  description: 'The gap between a working model and a trusted decision system is organizational: governance, stakeholder alignment, and change management. I build the infrastructure that bridges that gap.'
}, {
  title: 'Measurement without governance is just expensive guessing.',
  description: 'I design measurement platforms with explicit certification standards, release gates, and decision frameworks that make AI outputs trustworthy enough for nine-figure allocation decisions.'
}, {
  title: 'The best product leaders kill failing investments as readily as they launch new ones.',
  description: 'I terminated a $4M/year LLM initiative at Genentech after rigorous TCO analysis. Building credibility means being willing to say no when the evidence demands it.'
}];
export function WhatIBelieve() {
  return <section className="py-24 md:py-32 border-t border-border" data-id="element-181">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-16" data-id="element-183">
          <h2 className="text-2xl md:text-3xl font-semibold text-primary tracking-tight" data-id="element-184">
            What I Believe
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-185">
          {beliefs.map((belief, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-card p-8 md:p-10 rounded-2xl flex flex-col h-full" data-id="element-186">
              <h3 className="text-xl font-semibold text-primary mb-4 tracking-tight leading-snug" data-id="element-187">
                {belief.title}
              </h3>
              <p className="text-secondary leading-relaxed flex-grow" data-id="element-188">
                {belief.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}